<template>
  <v-app-bar id="app-bar" absolute app color="transparent" flat height="75">
    <v-btn
      class="mr-3"
      elevation="1"
      fab
      small
      @click="$vuetify.breakpoint.smAndDown ? setDrawer(!drawer) : $emit('input', !value)"
    >
      <v-icon v-if="value">mdi-view-quilt</v-icon>

      <v-icon v-else>mdi-dots-vertical</v-icon>
    </v-btn>

    <v-toolbar-title class="hidden-sm-and-down font-weight-light" v-text="title" />

    <v-spacer />

    <div class="mx-3" />

    <v-btn class="ml-2" min-width="0" text to="/user">
      <v-icon>mdi-account-settings</v-icon>
    </v-btn>

    <v-menu bottom left min-width="200" offset-y origin="top right" transition="scale-transition">
      <template v-slot:activator="{ attrs, on }">
        <v-btn class="ml-2" min-width="0" text v-bind="attrs" v-on="on">
          <v-icon>mdi-account</v-icon>
          {{displayName}}
        </v-btn>
      </template>

      <v-list :tile="false" flat nav>
        <template v-for="(p, i) in profileMenuItems">
          <v-divider v-if="p.type === 'divider'" :key="`divider-${i}`" class="mb-2 mt-2" />

          <v-list-item v-else-if="p.type === 'signout-action'" :key="`item-${i}`" @click="signOut">
            <v-list-item-title v-text="p.title" />
          </v-list-item>

          <app-bar-item v-else :key="`item-${i}`" :to="p.to">
            <v-list-item-title v-text="p.title" />
          </app-bar-item>
        </template>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
// Components
import { VHover, VListItem } from "vuetify/lib";

// Utilities
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
  name: "ParentCoreAppBar",

  components: {
    AppBarItem: {
      render(h) {
        return h(VHover, {
          scopedSlots: {
            default: ({ hover }) => {
              return h(
                VListItem,
                {
                  attrs: this.$attrs,
                  class: {
                    "black--text": !hover,
                    "white--text secondary elevation-12": hover
                  },
                  props: {
                    activeClass: "",
                    dark: hover,
                    link: true,
                    ...this.$attrs
                  }
                },
                this.$slots.default
              );
            }
          }
        });
      }
    }
  },

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    title: "Parent Management Section"
  }),

  computed: {
    ...mapState("siderbarService", {
      drawer: "drawer"
    }),
    ...mapGetters("userAccountService", {
      profileMenuItems: "profileMenuItems"
    }),
    ...mapGetters("authenticationService", {
      displayName: "displayName"
    })
  },

  methods: {
    ...mapMutations("siderbarService", {
      setDrawer: "SET_DRAWER"
    }),
    signOut() {
      this.$store
        .dispatch("authenticationService/signOut")
        .then(() => {
          this.$router.push("/pages/login");
        })
        .catch(error => {});
    }
  }
};
</script>
